import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LanguageSettings } from '../../environments/environment';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(private readonly http: HttpClient, private readonly prefix: string, private readonly suffix: string) {}

  public getTranslation(lang: string): Observable<any> {
    const serverUrl = `${this.prefix}/${lang}${this.suffix}`;
    const localUrl = `/assets/i18n/${LanguageSettings.defaultSelectedLang}.json`;
    return this.http.get(serverUrl).pipe(
      catchError(() => {
        return this.http.get(localUrl).pipe(
          catchError(() => {
            console.error(`Could not load translation file: ${localUrl}`);
            return of({});
          })
        );
      })
    );
  }
}
